import "client-only"

import { AppChannel, type Channel } from "@/config/channel"
import { arrayCheckbox } from "@/config/consts"
import { getAuthType } from "./auth-type"
import { getSearchParamsForLocation } from "./router-helpers"
import { safeWindow } from "./safe-window"
import { isHttpOrHttpsUrl } from "./url"

export function getConfigParams(defaultParams: URLSearchParams | null = null) {
  const searchParams = getSearchParamsForLocation(
    safeWindow()?.location?.search ?? "",
    defaultParams,
  )

  const siteIdParam = searchParams.get("siteid")
  const cancelcallbackurlParam =
    searchParams.get("cancelcallbackurl") ??
    searchParams.get("cancelCallbackUrl")
  const endCallbackUrlParam =
    searchParams.get("endcallbackurl") ?? searchParams.get("endCallbackUrl")
  const contoParam = searchParams.get("conto")
  const pvdParam = searchParams.get("pvd")
  const flagContoParam = searchParams.get("flagConto")
  const authTypeParam = searchParams.get("auth-type")

  const channel = getChannel(siteIdParam)

  return {
    channel,
    cancelCallbackUrl: getCancelCallbackUrl(cancelcallbackurlParam, channel),
    endCallbackUrl: endCallbackUrlParam ?? safeWindow()?.APP_MAIN_SITE_HOMEPAGE,
    username: contoParam,
    pvd: pvdParam ?? "",
    flagConto: getFlagConto(flagContoParam, channel),
    authType: getAuthType(authTypeParam),
  } as const
}

export type ConfigParams = ReturnType<typeof getConfigParams>

function getChannel(siteidParam: string | null) {
  const numericSiteId = parseInt(siteidParam ?? "", 10)
  return !isNaN(numericSiteId)
    ? (numericSiteId as Channel)
    : AppChannel.PortaleWebFullResponsiveWwwSisalIt
}

function getCancelCallbackUrl(
  cancelCallbackUrlParam: string | null,
  channel: Channel,
) {
  if (cancelCallbackUrlParam && isHttpOrHttpsUrl(cancelCallbackUrlParam)) {
    return cancelCallbackUrlParam
  }

  const defaultCancelCallbackUrl =
    channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt
      ? safeWindow()?.APP_MAIN_SITE_HOMEPAGE
      : "https://appmobile.sisal.it/?appFunc=close"

  return defaultCancelCallbackUrl
}

function getFlagConto(flagContoParam: string | null, channel: Channel) {
  const numericFlagConto = parseInt(flagContoParam ?? "", 10)
  if (!isNaN(numericFlagConto)) {
    return numericFlagConto
  }

  const defaultFlagConto = arrayCheckbox.includes(channel) ? 0 : 1

  return defaultFlagConto
}
